import React, { memo } from 'react';

import { Sidebar } from '@pascal/pascal-core';
import ResultWr from './resultWr';

import LimitsAndPayouts from './limitsAndPayouts';
import {
  resultColumns,
  limitPayoutColumns
} from "./columns";

export const PayoutsAndResultsContainer = memo(() => {
  return (
    <Sidebar
      results={ResultWr}
      limitsPayoutsWr={LimitsAndPayouts}
      resultsColumns={resultColumns}
      payoutsColumns={limitPayoutColumns}
    />
  );
});
